<template>
<h4 class="text-primary font-semibold mt-3 mb-2">
<template v-if="loading">
	<i class="pi pi-spin pi-spinner text-primary" style="font-size: 1em"></i>
</template>
<template v-else>
	<template v-if="resolved_data || resolved_data===0">
		{{ $filters.numberformatwithdigits( resolved_data,maxfraction)}}
	</template>
	<template v-else>
		-
	</template>
</template>
	
</h4>
</template>

<script>
export default {

  name: 'ColumnCalculation',
  props:["data","index"],
  data () {
    return {
    	loading:true,
    	resolved_data:null,
    }
  },
  computed:{
  	maxfraction()
    {
      if(this.data)
      {
        if(this.data.allowed_fraction)
        {
          return this.data.allowed_fraction
        }
        return 8
      }
      return 0
    },
  	inputfields_updating()
  	{
  		return this.$store.state.evaluation.inputfields_updating
  	},
  },
  watch:{
  	inputfields_updating(newval,oldval)
  	{
  		if(!newval)
  		{  			
  			this.resolveAll()
  		}
  	}
  },
  async mounted()
  {  	
  	this.resolveAll()
  },
  methods:{
  	async resolveAll()
  	{
  		
  		this.loading = true
  		let resolved_value =  await this.resolveData(this.data)	  	
	  	if(resolved_value || resolved_value===0)
	  	{	  		
	  		if(isFinite(resolved_value))
	  		{
		  		this.resolved_data =  await resolved_value;
	  			if(this.data.submit_to_db)
		  		{ 			
	  						this.submitCalculatedDataForColumn(this.data,resolved_value)	
		  		}	  			
	  		}
	  		else
	  		{
	  			this.resolved_data =  null
	  			if(this.data.submit_to_db)
		  		{ 			
	  						this.submitCalculatedDataForColumn(this.data,resolved_value)	
		  		}
	  		}	  		
	  	}
	  	
	  	this.loading =  await false
  	},
  		
  		
  }
}
</script>

<style lang="css" scoped>
</style>